import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehz2v8dnew: FaireProductEntity = {
  token: "p_ehz2v8dnew",
  type: "product",
  name: "Bonito Crunch | Smoky Umami Chili Crisp",
  brandToken: "b_4zww6v8k83",
  brandName: "Ikeuchi",
  imageUrl:
    "https://cdn.faire.com/fastly/853fbf3894a413ff1294277b081a691b4799bed52b79d42f16fc561841ed3cd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a200966709c1f187d1c092c989caabaebbe2eda0e8be9c6b89a31bbe05ccb087.jpeg",
    "https://cdn.faire.com/fastly/25844f77f1fe38a3671d3af35430a5e53d997305ea60ba060fd9298ec839323c.jpeg",
    "https://cdn.faire.com/fastly/b129ff28cb5f50becb65946d34a2003d23bc2ef98f2f8b3e2f4bca610f694e4d.jpeg",
    "https://cdn.faire.com/fastly/e58b2c82b20ffeaea455ccf76f27a02df7605878691cd4316acdd2a9096b5b1b.jpeg",
    "https://cdn.faire.com/fastly/ddba84487d9b6a7d8a6a6521c3e2e4da22f3e7fef2d0439af18a6c8744cf297a.jpeg",
  ],
  priceDollars: 9,
  description:
    "Bonito Crunch compliments any dish.\n\nSavory, crunchy, and umami-rich — the ultimate finishing touch for anything!\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:14.416Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
